import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export default function PreviousPage({ customPath, customText, preserveState = false }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGoBack = () => {
        const navigationState = { from: preserveState ? 'internal' : 'sidebar' };
        
        if (customPath) {
            navigate(customPath, { state: navigationState });
        } else {
            navigate(-1, { state: navigationState });
        }
    };

    return (
        <button 
            className="previous-page-btn" 
            onClick={handleGoBack}
            title={customText || t('common.previousPage')}
        >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>{customText || t('common.previousPage')}</span>
        </button>
    );
} 